<template>
  <BModal :id="id" :visible="show" scrollable size="md" hide-footer @hide="$emit('hide')">
    <template #modal-header>
      <h5 class="modal-title">Bulk Discounts</h5>
      <button type="button" class="close" aria-label="Close" @click="$emit('hide')">
        <span aria-hidden="true">&times;</span>
      </button>
    </template>
    <BulkDiscountList :bulk-discounts="bulkDiscounts" />
  </BModal>
</template>

<script>
import BulkDiscountList from "./BulkDiscountList.vue";

/**
 * Bulk discounts on their own, for the surfaces that show them without a buyer's pricing tier.
 * The toolbar's combined button opens DiscountsModal instead.
 */
export default {
  components: { BulkDiscountList },
  props: {
    show: { type: Boolean, required: true },
    id: { type: String, default: "bulkDiscountsModal" },
    bulkDiscounts: { type: Array, required: true },
  },
  emits: ["hide"],
};
</script>
